import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Stack,
} from "@mui/material";

/*
Carrier names vary in length, so the placeholder names do too — a column of
identical bars reads as a table rather than as a list about to fill in. The
widths are distinct, so each doubles as the key for its row, and the number of
them is the most rows this can draw.
*/
const NAME_WIDTHS = ["70%", "45%", "60%", "35%", "55%"];

const NAME_SKELETON_HEIGHT = 20;
const CHIP_SKELETON_WIDTH = 56;
const CHIP_SKELETON_HEIGHT = 24;
const LOGO_SKELETON_SIZE = 28;

interface Props {
  rowCount: number;
  label: string;
}

/*
Placeholder rows laid out like `CarrierSearchResultRow`, so results settle into
the space the skeleton already occupies instead of the dropdown jumping when a
page arrives. Rendered outside the listbox, which holds only real options.
*/
export function CarrierSearchResultRowsSkeleton(props: Props) {
  const { rowCount, label } = props;

  return (
    <Box role="status" aria-label={label}>
      {NAME_WIDTHS.slice(0, rowCount).map((nameWidth) => (
        <ListItem key={nameWidth} sx={{ py: 1 }}>
          <ListItemIcon sx={{ minWidth: 40 }}>
            <Skeleton
              variant="rounded"
              width={LOGO_SKELETON_SIZE}
              height={LOGO_SKELETON_SIZE}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Stack direction="row" alignItems="center" spacing={1}>
                <Skeleton
                  variant="text"
                  width={nameWidth}
                  height={NAME_SKELETON_HEIGHT}
                />
                <Skeleton
                  variant="rounded"
                  width={CHIP_SKELETON_WIDTH}
                  height={CHIP_SKELETON_HEIGHT}
                />
              </Stack>
            }
            primaryTypographyProps={{ component: "div" }}
          />
        </ListItem>
      ))}
    </Box>
  );
}
